export const QA_NAME_ATTACH_TASKS_MODAL = 'tasksAttachModal'

export const ATTACH_TASKS_PAGINATION_PAGE_SIZE_KEY = 'size'

export const ATTACH_TASKS_ORDERING = ['phase_position', 'position']
